import { Breadcrumb, Col, Row, Button, MenuProps, Dropdown } from "antd";
import { CaretDownOutlined } from "@ant-design/icons";
import { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { useParams, useLocation } from "react-router-dom";
import { useMutation } from "react-query";
import PriceListDetails from "./PriceListDetails";
import ResetButton from "../UI/ResetButton/resetbutton";
import { Search } from "../UI/Search/Search";
import CancelBtn from "../UI/CancelButton/CancelBtn";
import { getPriceListDetails } from "../../api/priceLists";
import { PriceListDetailsInterface, CurrentPriceList } from "./Interfaces";
import FileDownloader from "./FileDownloader";
import FileUploader from "./FileUploader";

const PriceDetails = () => {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const title = searchParams.get('title');

  const { id } = useParams();
  const { t } = useTranslation("common");
  const [tableKey, setTableKey] = useState(0);
  const [searchText, setSearchText] = useState("");
  const [page, setPage] = useState<number>(1);
  const [priceListDetails, setPriceListDetails] = useState<PriceListDetailsInterface[]>([])
  const [priceListDetailsSearch, setPriceListDetailsSearch] = useState<PriceListDetailsInterface[]>([])
  const [currentPriceList, setCurrentPriceList] = useState<CurrentPriceList>({
    activateOn: '',
    endDate: null,
    expiryDate: null,
    id: 0,
    isActivated: false,
    name: '',
    startDate: null
  })

  const { mutateAsync: getPriceListDetailsMutation, isLoading } = useMutation(
    "getPriceListDetails",
    ({ search, page }: { search: string; page: number }) =>
      getPriceListDetails({ id: parseInt(id ?? '0'), page: page * 10 + 10, q: search }),
    {
      onSuccess: ({ data }) => {
        setPriceListDetails(data.data);
        setCurrentPriceList(data.priceList)
        setPriceListDetailsSearch(data.data)
      },
    }
  );

  useEffect(() => {
    getPriceListDetailsMutation({ page: page, search: searchText })
  }, [])

  const handleResetFilters = () => {
    if (!searchText) return
    setSearchText("");
    setTableKey((tableKey) => tableKey + 1);
    setPriceListDetails(priceListDetailsSearch)
  };

  const handleSearch = () => {
    const filteredData = priceListDetailsSearch.length > 0 ? priceListDetailsSearch : priceListDetails;
    const filteredList = filteredData.filter(item => item.item.name.toLowerCase().includes(searchText.trim().toLowerCase()) || item.item.barcode.includes(searchText.trim().toLowerCase()));
    setPriceListDetails(filteredList);
  };

  useEffect(() => {
    handleSearch()
  }, [searchText])

  const baseURL = (window as any).REACT_APP_BASE_API_URL

  const items: MenuProps["items"] = [
    {
      label: (
        <FileDownloader fileName={'Sheet Price Lists Details'} btnName={t('download')} link={baseURL + `/price-list/${currentPriceList.id}/export`} />
      ),
      key: "1",
    },
    {
      label: (
        <FileUploader setPriceListDetails={setPriceListDetails} setPriceListDetailsSearch={setPriceListDetailsSearch} btnName={t('upload')} uploadUrl={baseURL + `/price-list/${currentPriceList.id}/import?limit=999999`} />
      ),
      key: "2",
    },
  ];
  const menuProps = {
    items,
  };

  return (
    <>
      <Row gutter={[10, 10]} style={{ width: "100%" }}>
        <Col offset={1} span={11}>
          <Breadcrumb
            items={[
              {
                title: <Link to="/main">{t("home")}</Link>,
              },
              {
                title: <Link to="/priceList">{t("price-List")}</Link>,
              },
              {
                title: (
                  <span className="breadcrumbcolor">
                    {t("price-list-details")}
                  </span>
                ),
              },
            ]}
          />
        </Col>
        <Col className="editTitle" offset={1} span={22}>
          {/* {title} */}
        </Col>

        <Col offset={1} span={4}>
          <Search
            value={searchText}
            onChange={(e: any) => setSearchText(e.target.value)}
          />
        </Col>

        <Col
          style={{ display: "flex", justifyContent: "flex-end", gap: "20px" }}
          offset={16}
          span={2}
        >
          <ResetButton
            onClick={() => {
              handleResetFilters();
            }}
          />
          <Dropdown trigger={["click"]} menu={menuProps}>
            <Button
              type="primary"
              style={{ background: "#1677FF", color: "#fff", height: "40px" }}
            >
              <CaretDownOutlined />
              {t("action")}
            </Button>
          </Dropdown>
        </Col>
        <Col offset={1} span={22}>
          <PriceListDetails tableKey={tableKey} priceListDetails={priceListDetails} currentPriceListId={currentPriceList.id} setPriceListDetails={setPriceListDetails} isLoading={isLoading} setPriceListDetailsSearch={setPriceListDetailsSearch} />
        </Col>
      </Row>
      <Row>
        <Col offset={1} style={{ paddingTop: "17rem" }}>
          <CancelBtn />
        </Col>
      </Row>
    </>
  );
};

export default PriceDetails;
